export const MESSAGE_TYPE = {
    COMMENT: 'comment',
    QUESTION: 'question',
};

export const FILTERS_EPISODE = {
    all: "ALL",
    current: "CURRENT",
};

export const SORT_NEW_TO_OLD = "SORT_NEW_TO_OLD";
export const SORT_POPULAR = "SORT_POPULAR";
export const SORT_RATING = "SORT_RATING";

export const SORT_QUERY = {
    SORT_NEW_TO_OLD: 'id',
    SORT_POPULAR: 'likes',
    SORT_RATING: 'rating',
};

export const SORT_VALUES = {
    [SORT_POPULAR]: [
        { label: "messages.sort.newToOld", value: SORT_NEW_TO_OLD },
        { label: "messages.sort.popular", value: SORT_POPULAR, isDefault: true }
    ],
    [SORT_RATING]: [
        { label: "messages.sort.rating", value: SORT_RATING, isDefault: true },
        { label: "messages.sort.newToOld", value: SORT_NEW_TO_OLD },
    ],
};

export const FILTER_VALUES = [
    { label: "messages.filterEpisode.all", value: FILTERS_EPISODE.all, isDefault: true },
    { label: "messages.filterEpisode.current", value: FILTERS_EPISODE.current },
];

export const MESSAGE_LIMIT = 100;
